import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'finish-voting-dialog',
    templateUrl: './finish-voting-dialog.component.html',
    styleUrls: ['./finish-voting-dialog.component.scss'],
    standalone: false
})

export class FinishVotingDialogComponent {
  publishEndResult = false;
  title = '';
  checkboxTitle = '';
  fromDate = new Date();
  toDate = null;

  constructor(public dialogRef: MatDialogRef<FinishVotingDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService) {
    this.title = this.translate.get('dynamicContent.finishVoting');
    this.checkboxTitle = this.translate.get('dynamicContent.publishEndResult');
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      publishEndResult: this.publishEndResult,
      publishEndResultMoment: this.toDate,
      finished: true
    });
  }
}
